import { render, staticRenderFns } from "./weekTemplate.vue?vue&type=template&id=4d6761b8&scoped=true&"
import script from "./weekTemplate.vue?vue&type=script&lang=js&"
export * from "./weekTemplate.vue?vue&type=script&lang=js&"
import style0 from "./weekTemplate.vue?vue&type=style&index=0&id=4d6761b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6761b8",
  null
  
)

export default component.exports